var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 154.573,
    height: 124.143,
    viewBox: "0 0 154.573 124.143",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Unspecified",
    transform: "translate(0 71.793) rotate(-30)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7332",
    "data-name": "Group 7332",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6852",
    "data-name": "Path 6852",
    d: "M87.751,14.438,81.5,8.151a3.881,3.881,0,0,0-2.565-.866,3.759,3.759,0,0,0-1.676.517,4.472,4.472,0,0,0-1.935,2.542l.124,6.85h-65.4L0,23.932v2.418L12.812,39.163h7.762l6.457-5.141,8.02,8.358,6.4.214,7.21-6.569,8.774,8.527,7.48-6.086h9.46c-.113,2.351-.236,4.7-.349,7.064a4.909,4.909,0,0,0,.54,2.61,3.8,3.8,0,0,0,1.845,1.878,3.36,3.36,0,0,0,3.206-.495c2.283-1.665,4.567-3.341,6.85-5.006a31.765,31.765,0,0,0,7.177,8.605,30.232,30.232,0,0,0,35.5,2.891,30.22,30.22,0,0,0,2.182-50.091A30.528,30.528,0,0,0,118.055.366a30.224,30.224,0,0,0-13.69,1A31.3,31.3,0,0,0,87.751,14.438Zm39.539,6.637a9.371,9.371,0,1,1-11.17,7.131A9.375,9.375,0,0,1,127.29,21.075Z",
    transform: "translate(0 0)",
    fill: "#3c3c3b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.61e8b9b05370a2c59a322b7f91bc7940.svg";
export { ForwardRef as ReactComponent };